import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function TextStyles(params = {}) {
    return {
        "& .text": {},
    };
}

export default function Text(props) {
    const LI = useLoremIpsum();

    const variables = props.variables;

    let text = props.text;
    if (!props.text && props.useVariable) {
        if (variables[props.useVariable]) {
            text = variables[props.useVariable];
        }
    }

    const elProps = toElementProps(props, { className: ["text"] });
    return <p {...elProps}>{text || LI.Numbers[0].text}</p>;
}
